import React, {useEffect, useState, useRef} from 'react';
import {Col, Row, Spacer, View} from '@amzn/stencil-react-components/layout';
import {useBreakpoints} from "@amzn/stencil-react-components/responsive";
import {Text} from '@amzn/stencil-react-components/text';
import { getEnvironmentBasedURL} from './Utils';
import './HomePage.css';
import {UNAUTHORISED_TIMEOUT, HOMEPAGE_MESSAGE_BUNDLE_NAME} from "src/constants";
import { useBundle } from '@amzn/react-arb-tools';
import { t } from '../helpers';
import { metricsHelper, MetricNames } from '../metrics';

export const HomePageUnauthorised = () => {
    const {matches} = useBreakpoints();
    const isMobile = matches.s || matches.m;
    const stage: string = "beta";
    const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);
    document.title = t(bundle, 'page_title') || "My HR Lite Welcome Page";
    let [timer, setTimer] = useState(UNAUTHORISED_TIMEOUT)

    // Track if metrics have been published to avoid duplicate emissions
    const metricsPublishedRef = useRef(false);

    // Publish UnauthorizedPageView metric on mount
    useEffect(() => {
        if (metricsPublishedRef.current) {
            return;
        }
        metricsPublishedRef.current = true;

        // This metric indicates a user landed on the unauthorized page,
        // which likely means auth failed or timed out externally
        metricsHelper.publishCounter(MetricNames.UNAUTHORIZED_PAGE_VIEW);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (timer <= 0) {
                redirect();
            } else {
                setTimer(timer - 1);
            }
        }, 1000);
    }, [timer]);

    const redirect = () => {
        window.location.href = "/";
    }

    return (
        <View>
            <View className='header'>
                <img
                    className='header-image'
                    role="presentation"
                    height="44px"
                    width="92px"
                    alt={t(bundle, 'myhr_logo_alt')}
                    src={getEnvironmentBasedURL('MyHRLogo')}
                />
            </View>

            <Col>
                <Col margin={'106px 506px 0 463px'}>
                    <img className='image-left'
                         role="presentation"
                         alt={t(bundle, 'unauthorised_image_alt')}
                         height={"329px"}
                         width={"471px"}
                         style={{alignSelf: "center"}}
                         src={getEnvironmentBasedURL('Unauthorised')}
                    /></Col>
                    <Spacer height="33px"/>
                    <Col margin={'0 416px 0 416px'} style={{alignSelf: "center"}}>
                        <Text className={"unauthorised-text-1-l"}>
                            {t(bundle, 'unauthorised_title')}
                        </Text>
                    </Col>
                    <Spacer height="33px"/>
                    <Col>
                        <Text className={"unauthorised-text-2-l"}>
                            {t(bundle, 'unauthorised_help_text')}
                        </Text>
                    </Col>
                    <Spacer height="32px"/>
                    <Col >
                        <Row width ={"503px"} height={"32px"} style={{alignSelf: "center", justifyContent: "center"}} margin={'0 469px 267px 468px'}>
                            <Text className={"unauthorised-text-3-l"}>
                                {t(bundle, 'automatic_logout_in')}
                            </Text>  <Text className={"unauthorised-text-4-l"}> &nbsp;
                            {t(bundle, 'seconds_remaining', { count: timer })}
                        </Text>
                        </Row>
                    </Col>
                </Col>
        </View>
    );
};
